import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';

const allRoutes = [{ path: '/', element: <Home /> }];

function App() {
    return (
        <BrowserRouter>
            <Routes>
                {allRoutes.map(({ path, element }, index) => (
                    <Route key={index} path={path} element={element} />
                ))}
            </Routes>
        </BrowserRouter>
    );
}

export default App;
